import { IMobileUniqueIssuesResult } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { MobileDashboardUniqueIssuesQuery } from '../MobileUniqueIssues.generated';

export const transformMobileUniqueIssuesResults = (
	rawResults: MobileDashboardUniqueIssuesQuery
): IMobileUniqueIssuesResult => {
	const issues =
		rawResults.uniqueness_issues?.filter(returnNonNull).map((issue) => ({
			id: issue.uniqueness_id,
			issueId: issue.last_issue_id,
			runId: issue.run_id,
			issueType: issue.issue_type,
			severity: issue.severity,
			appId: issue.page_url ?? '',
			elementDescription: issue.page_title ?? '',
			firstSeen: issue.first_seen,
			lastSeen: issue.last_seen,
			instanceCount: 1
		})) ?? [];

	return {
		issues,
		totalCount: rawResults.total?.[0]?.uniqueness_id_count ?? 0,
		unfilteredTotal: rawResults.unfilteredTotal?.[0]?.uniqueness_id_count ?? 0
	};
};
